import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Form } from 'react-bootstrap';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Link, useNavigate } from 'react-router-dom';
import { addfaq } from '../../actions/users';
import { isEmpty } from '../../actions/commonFunction';
import { toast } from 'react-toastify';


const initialFormValue = {
    'question': "",
    'answer': "",
  
}


const FaqAdd = () => {


    const navigate = useNavigate();


    const [validateError, setValidateError] = useState({});
    const [categoryname, setCategoryname] = useState('');
    const [question, setquestion] = useState("");
    const [answer, setanswer] = useState("");

    useEffect(() => {
        //getCategorytype()
       }, [])
       // function
     
       const onChange = (e) => {
         setquestion(e.target.value)
         
      
       }
       const onEditorChange = (evt) => {
         var description_text = evt; 
         
         setanswer(description_text);
       }
     
       const handleFormSubmit = async (e) => {
         e.preventDefault();
         let reqData = {
             //type,
             question,
             answer
             
         }
         let { error } = await addfaq(reqData);
         
         if (isEmpty(error)) {
           toast.success('Faq added successfully', 1000);
           navigate('/faqlist')
         } else {
           setValidateError(error);
         }
       }

    return (
        <Layout>
            <div className="faqadd">
                <Link to="/faqList" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">Create a New Faq</h1>
                <div className="cardbox">
                    <Form className='mb-4'>
                        <Form.Label>Question</Form.Label>
                        <Form.Control type="text" placeholder="Question" className="w-auto mb-2" id="question" value={question||''} onChange={onChange} />
                        {
                          validateError.question && <span className="text-danger ">{validateError.question}</span>
                      }
                    </Form>

                    <Form.Label>Answer:</Form.Label>
                    <SunEditor height={200} defaultValue={answer||''} onChange={onEditorChange} placeholder='Enter answer' />
                    
                    <div className='mt-2'>
                    {
                      validateError.answer && <span className="text-danger">{validateError.answer}</span>
                    }
                    </div>
                    
                    <button type="button" className="btn sitebtn py-2 px-3 mt-3" onClick={handleFormSubmit}>Add</button>
                </div>
            </div>
        </Layout>
    )
}

export default FaqAdd;